// Use the production domain for all links
export const BASE_URL = 'https://zentrixinsights.com';

export const generateRegistrationLink = (companySlug: string, positionId?: string): string => {
  const base = `${BASE_URL}/register/${companySlug}`;
  return positionId ? `${base}?position=${positionId}` : base;
};

export const generateWorkBehaviorLink = (companySlug: string, positionId?: string): string => {
  let url = `${BASE_URL}/work-behavior-standalone?company=${companySlug}`;
  if (positionId) url += `&position=${positionId}`;
  return url;
};

export const generateCognitiveAssessmentLink = (companySlug: string): string => {
  return `${BASE_URL}/cognitive?company=${companySlug}`;
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    // Fallback for browsers that don't support clipboard API
    try {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      const success = document.execCommand('copy');
      document.body.removeChild(textArea);
      return success;
    } catch (fallbackError) {
      console.error('Failed to copy to clipboard:', fallbackError);
      return false;
    }
  }
};
